/**
 * Feature Flag System Exports
 */

// Legacy compatibility import
import { featureFlags as flags } from './features';

export { FeatureFlags, featureFlags } from './features';
export { detectDeploymentType, getDeploymentConfig, deploymentConfig } from './deployment';
export type { DeploymentType, DeploymentConfig } from './deployment';
export { useTenantFeatures } from './tenantFeatures';
export type { TenantFeatures } from './tenantFeatures';

export namespace FeatureServices {
  export function isSubscriptionsEnabled(): boolean {
    return flags.isSubscriptionsEnabled();
  }

  export function isStripeEnabled(): boolean {
    return flags.isStripeEnabled();
  }

  export function isAnalyticsEnabled(): boolean {
    return flags.isAnalyticsEnabled();
  }
}